export const RESUME_URL =
  "https://customer-assets.emergentagent.com/job_323537d3-9e6f-45c6-b455-e58f3404814f/artifacts/kqzy409r_Vatushi_Moondra_Resume.pdf";

export const PROFILE = {
  name: "Vatushi Moondra",
  role: "Senior UX Designer",
  headline:
    "Designing intuitive digital experiences through strategy, collaboration, and human-centered thinking.",
  email: "vatushimoondra15@gmail.com",
  phone: "+91 84204 09190",
  linkedin: "https://www.linkedin.com/in/vatushi-moondra-29ab34159/",
  location: "India",
  yearsExperience: "9",
};

export const ABOUT = {
  lead:
    "I'm a Senior UX Designer with 9 years of experience crafting intuitive, human-centered digital products.",
  paragraphs: [
    "My work spans enterprise platforms, data-driven products, dashboards, and design systems — translating complex operational and business challenges into scalable, elegant user experiences. I've partnered with global organisations including Pfizer, Novartis, Sanofi, Microsoft, and Abbott.",
    "I lead the full UX lifecycle: research and journey mapping, information architecture, interaction design, prototyping, and usability testing. I care deeply about stakeholder alignment, accessibility, and design that earns the trust of the people who use it every day.",
  ],
  stats: [
    { value: "9+", label: "Years of experience" },
    { value: "45+", label: "Fortune 500 clients" },
    { value: "80+", label: "Products & platforms" },
  ],
};

export const EXPERIENCE = [
  {
    company: "ZS Associates",
    title: "Senior UX Designer",
    period: "2021 — Present",
    location: "Pune, India",
    points: [
      "Lead the design of enterprise platforms and data-driven digital products for global clients including Pfizer, Novartis, Sanofi, Microsoft, and Abbott.",
      "Transform complex operational and business challenges into scalable, human-centered user experiences with multidisciplinary teams.",
      "Identify behavioral patterns and usability gaps through workflow analysis and user journey mapping.",
      "Completed an intensive 40-hour UX & AI masterclass, conceptualising AI-driven product experiences.",
    ],
  },
  {
    company: "Onething Design",
    title: "Senior UX Designer",
    period: "2019 — 2021",
    location: "Gurugram, India",
    points: [
      "Led UX initiatives for Fortune 500 clients, owning design execution from research and wireframing to high-fidelity prototyping.",
      "Facilitated stakeholder discussions and mentored junior designers.",
      "Solved complex product challenges using strategic design thinking.",
    ],
  },
  {
    company: "Think Design Collaborative",
    title: "UX Designer",
    period: "2019",
    location: "Bengaluru, India",
    points: [
      "Collaborated on a full-cycle product design engagement.",
      "Translated business requirements and user needs into streamlined workflows and interface solutions.",
    ],
  },
  {
    company: "Ernst & Young — FCUX",
    title: "UX & UI Designer",
    period: "2018 — 2019",
    location: "Pune, India",
    points: [
      "Gained hands-on experience working within agile teams.",
      "Developed a strong understanding of end-to-end product design workflows.",
    ],
  },
];

export const EDUCATION = [
  {
    school: "L'école de Design Nantes Atlantique",
    degree: "Digital Media Design — User Experience & Interface",
    period: "2017 — 2018",
  },
  {
    school: "MIT Institute of Design",
    degree: "Communication Design — Graphics & UX Design",
    period: "2014 — 2018",
  },
];

export const SKILL_GROUPS = [
  {
    title: "UX Strategy",
    items: ["Design Thinking & Strategy", "Journey Mapping", "Information Architecture", "Stakeholder Management"],
  },
  {
    title: "UI Design",
    items: ["Visual Design & Layout", "Typography & Color Theory", "Dashboards & Data Visualization", "Accessibility-focused UI"],
  },
  {
    title: "Research",
    items: ["User Research & Personas", "Usability Testing", "Accessibility", "Behavioral Analysis"],
  },
  {
    title: "Design Systems",
    items: ["Component Libraries", "Design Tokens", "Branding & Guidelines", "Scalable Patterns"],
  },
  {
    title: "Collaboration",
    items: ["Cross-functional Collaboration", "Agile / Scrum", "Mentoring", "Design Facilitation"],
  },
  {
    title: "Tools",
    items: ["Figma", "FigJam", "Adobe Creative Suite", "Axure RP", "Framer AI", "Miro", "Jira & Confluence", "Maze", "Attention Insight"],
  },
];
